import { SCENE_INTERACTION } from "../../constants/scene";
import { SOCKET_EVENTS } from "../../socket/Events";
import { getImgThumb } from "../engine/helpers/getImageType";
import { SCENE_EVENTS } from "../MVC/Model";
import { CHAT_EVENTS } from "../../constants/chat";
import ChatPanelTitle, { types } from "./ChatPanelTitle";
import NewChatComponent from "./NewChatComponent";
import { ChatsPanel } from "./UI/Chat-New";
import ChatNotifications, { CHAT_NOTIFICATION } from "./ChatNotifications";
import { AMPLITUDE_EVENTS, trackAnalytics } from "../Tracking/baglessAnalytics";

export default class ChatPanel {
  constructor({ model }) {

    this.wrapper = $(ChatsPanel());
    this.model = model;
    this.socket = model.socket;

    this.sceneChats = {};
    this.privateChats = {};
    this.chessChats = {};
    this.listCurrentRoomChats = {};
    this.listLatestChats = {};
    this.currentRoomSceneTitles = {};
    this.latestRoomSceneTitles = {};

    this.currentRoomChats = this.wrapper.find(".section-title")[0];
    this.latestChats = this.wrapper.find(".section-title")[1];
    this.countChats = this.wrapper.find(".chat-count")[0];

    this.summaryNotificationCounter = $("#chat-list-total-badge");
    this.summaryNotificationCounter.hide();

    this.worldChatTitle = new ChatPanelTitle({
      id: "single-chat-world",
      img: this.model.sceneData.previewBackgroundImage.mediumPath,
      title: `${$trans('room-chat-header-text')}:${this.model.sceneData.name}`,
      lastMessage: "David Guetta: Give me back my dj set",
      timestamp: "Yesterday",
      container: this.currentRoomChats,
      model,
    });

    this.chatNotifications = new ChatNotifications({ model });
    this.chatNotifications.addEventListener(CHAT_NOTIFICATION.CHANGED, (e) => {
      const { data } = e;

      const totalCount = data.total;

      if (model.tourMode) {
        this.worldChatTitle.setNotificationBagdeNum(data.TOUR);
      } else {
        this.worldChatTitle.setNotificationBagdeNum(data.GLOBAL);
      }

      Object.keys(data.SCENE).forEach(key => {
        if (this.currentRoomSceneTitles[key]) {
          this.currentRoomSceneTitles[key].setNotificationBagdeNum(data.SCENE[key])
        }
      })
      Object.keys(data.PRIVATE).forEach(key => {
        if (this.latestRoomSceneTitles[key]) {
          this.latestRoomSceneTitles[key].setNotificationBagdeNum(data.PRIVATE[key])
        }
      })
      Object.keys(data.CHESS).forEach(key => {
        if (this.currentRoomSceneTitles[key]) {
          this.currentRoomSceneTitles[key].setNotificationBagdeNum(data.CHESS[key])
        }
      })

      this.summaryNotificationCounter.show();
      this.summaryNotificationCounter.html(totalCount)
      if (totalCount === 0) {
        this.summaryNotificationCounter.hide();
      }
    })

    this.initListeners();
    this.initChats();
    this.loadLatestChats();

    $(document.body).append(this.wrapper);
    this.close();

    $(document).on('click', '#chat-list-navbar-button', () => {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    })
  }

  get panelIcon() {
    return $("#chat-list-navbar-button");
  }

  initListeners() {
    this.wrapper.find(".icon-close").on("click", () => {
      this.close();
    });

    const closeEvents = [
      SCENE_EVENTS.NAVBAR_ITEM_CLICKED,
      SCENE_INTERACTION.PEOPLE_PANEL_OPENED
    ];
    closeEvents.forEach((event) => {
      this.model.addEventListener(event, (e) => {
        this.close();
      });
    });
    this.model.addEventListener(CHAT_EVENTS.JUST_CLOSE_CHAT_UI, () => {
      this.closeAllChats();
      this.close();
    })
    this.model.addEventListener(CHAT_EVENTS.OPEN_WORLD_CHAT, () => {
      this.closeAllChats();
      this.close();
      this.worldChat.open();

      this.model.resetChatState()
      this.model.chatState.globalChatVisible = true;
    })
    this.model.addEventListener(CHAT_EVENTS.OPEN_SCENE_CHAT, (e) => {
      const { id } = e.data;
      this.closeAllChats();
      this.close();
      this.sceneChats[id].open();

      this.model.resetChatState()
      this.model.chatState.sceneChatVisible = true;
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_ONE_ON_ONE, (e) => {
      const { id } = e.data;
      if (!this.privateChats[id]) {
        this.createPrivateChat(e);
      }
      this.closeAllChats();
      this.close();
      this.privateChats[id].open();

      this.model.resetChatState()
      this.model.chatState.oneOneOneChatVisible = true;
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_CHESS_CHAT, (e) => {
      const { id } = e.data;
      this.closeAllChats();
      this.close();
      if (this.chessChats[id]) {
        this.chessChats[id].open();
      }
    });
    this.model.socket.addEventListener(SOCKET_EVENTS.USER_ONE_ON_ONE_SENT, (e) => {
      if (!e.messagePayload) {
        return;
      }
      const { time, receiverId } = e.messagePayload;
      const tsRaw = typeof time !== 'undefined' ? time : Date.now();
      const numeric = Number(tsRaw);
      const tsMs = !isNaN(numeric) ? (numeric < 1e12 ? numeric * 1000 : numeric) : Date.now();
      $(`#chatUI-${receiverId}`).attr('last-timestamp', tsMs);
    });

    this.model.addEventListener(SCENE_EVENTS.CREATE_OFFLINE_CHAT, (e) => {
      const { id } = e.data;
      if (!this.privateChats[id]) {
        this.createPrivateOfflineChat(e);
      }
      this.closeAllChats();
      this.privateChats[id].open();
    });
    this.model.addEventListener(SCENE_EVENTS.CREATE_CHESS_CHAT, (e) => {
      const { id } = e.data;
      if (!this.chessChats[id]) {
        this.createChessChat(e);
      }
      this.closeAllChats();
    });
    this.model.addEventListener(SCENE_EVENTS.REMOVE_CHESS_CHAT, (e) => {
      const { id } = e.data;
      if (this.chessChats[id]) {
        this.chessChats[id].container.remove();
        delete this.chessChats[id];
        this.currentRoomSceneTitles[id].wrapper.remove();
        delete this.currentRoomSceneTitles[id];
      }
    });
    this.model.socket.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, (e) => {
      const { userId } = e.data;
      const user = this.model.socket.getUsersObject()[userId]
      const chatCard = $(`#chatUI-${userId}`);
      if (user && chatCard) {
        chatCard.find(".chat-title").text(user.userName);
        chatCard.find("img").attr("src", user.userAvatarUrl);
      }
    });
    this.socket.addEventListener(SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, (e) => {
      const id = e.data.userId || e.data.senderId;
      if (!this.privateChats[id]) {
        this.createPrivateChat(e);
      }
      this.closeAllChats();
      this.privateChats[id].open();
    });
    this.socket.addEventListener(SOCKET_EVENTS.ONE_ONE_ONE_MESSAGE_RECEIVED, (e) => {
      const { userId, senderId, time, timestamp } = e.data;
      if (userId && !this.privateChats[userId]) {
        this.createPrivateChat(e);
      }
      if (senderId && !this.privateChats[senderId] && senderId !== this.model.config.userId) {
        this.createPrivateChat(e);
      }
      const tsRaw = typeof time !== 'undefined' ? time : timestamp;
      const numeric = Number(tsRaw);
      const tsMs = !isNaN(numeric) ? (numeric < 1e12 ? numeric * 1000 : numeric) : Date.now();
      if (senderId) {
        $(`#chatUI-${senderId}`).attr('last-timestamp', tsMs);
      } else if (userId) {
        $(`#chatUI-${userId}`).attr('last-timestamp', tsMs);
      }
      this.sortAfterSection(this.wrapper.find('.chat-card[last-timestamp]').get(), true);
    });
    this.model.addEventListener(SCENE_INTERACTION.USER_SCENE_CHANGED, (e) => {
      const { sceneID } = e.data;
      this.hideAllTitles()
      if (this.currentRoomSceneTitles[sceneID]) {
        this.currentRoomSceneTitles[sceneID].show();
      }
    });
  }
  initChats() {
    this.worldChat = new NewChatComponent({ id: "single-chat-room", name: "Space Chat", type: types.ROOM, model: this.model });
    this.worldChat.container.find(".action-button--icon-three-dots").hide();
    this.model.sceneData.scenes.map(scene => {
      const { id, publicName, name } = scene;
      const _name = publicName || name;
      //creates chats on document
      this.sceneChats[id] = new NewChatComponent({ id, name: _name, type: types.SCENE, model: this.model });
      this.sceneChats[id].container.find(".action-button--icon-three-dots").hide();
      //creates titles inside panel - clicks - opens chat
      this.currentRoomSceneTitles[id] = new ChatPanelTitle({
        id,
        img: getImgThumb(scene.background.mediumPath),
        title: `Room Chat: ${_name}`,
        lastMessage: "Somebody: Hu ha",
        timestamp: "Yesterday",
        type: types.SCENE,
        container: this.currentRoomChats,
        model: this.model,
      });
      this.currentRoomSceneTitles[id].hide();
    });
    this.currentRoomSceneTitles[this.model.currentScene.id].show();
  }

  loadLatestChats() {
    const userId = this.model.config.userId;
    this.model.chatFetcher.getLatestChats((response) => {
      const { data } = response.data;
      data.forEach((chat) => {
        let id = chat.userId;
        let user = chat.user;
        if (Number(chat.userId) === Number(userId)) {
          id = chat.senderId;
          user = chat.sender;
        }
        if (!this.privateChats[id]) {
          this.createLatestChat(user);
        }
      });
    });
  }

  sortAfterSection(cards, newestFirst = true) {
    const withIndex = cards.map((el, idx) => ({ el, idx }));
    withIndex.sort((a, b) => {
      const ta = Number($(a.el).attr('last-timestamp')) || 0;
      const tb = Number($(b.el).attr('last-timestamp')) || 0;
      if (ta === tb) return a.idx - b.idx; // stable tie-breaker
      return newestFirst ? (tb - ta) : (ta - tb);
    });
    const anchor = this.wrapper.find('.section-title[data-lang="latest-chats"]');
    const fragment = $(document.createDocumentFragment());
    for (let i = 0; i < withIndex.length; i++) {
      fragment.append(withIndex[i].el);
    }
    fragment.children().insertAfter(anchor);
    this.countChats.innerHTML = withIndex.length;
  }

  open() {
    const wasOpen = this.opened;
    this.opened = true;
    this.wrapper.show();
    this.panelIcon.addClass("selected");
    this.model.dispatchEvent({ type: SCENE_INTERACTION.CHAT_PANEL_OPENED });

    const cards = this.wrapper.find('.chat-card[last-timestamp]').get();
    this.sortAfterSection(cards, true);
    if (!wasOpen) {
      trackAnalytics(this.model, AMPLITUDE_EVENTS.OPENED_CHAT, { t: Date.now() });
    }
  }
  close() {
    const wasOpen = this.opened;
    this.opened = false;
    this.wrapper.hide();
    this.panelIcon.removeClass("selected");
    this.model.resetChatState();
    this.model.dispatchEvent({ type: SCENE_INTERACTION.CHAT_PANEL_CLOSED });
    if (wasOpen) {
      trackAnalytics(this.model, AMPLITUDE_EVENTS.CLOSED_CHAT, { t: Date.now() });
    }
  }
  closeAllChats() {
    this.close();
    this.worldChat.close();
    Object.keys(this.sceneChats).forEach(key => {
      this.sceneChats[key].close();
    })
    Object.keys(this.privateChats).forEach(key => {
      this.privateChats[key].close();
    })
  }
  hideAllTitles() {
    Object.keys(this.currentRoomSceneTitles).forEach(key => {
      this.currentRoomSceneTitles[key].hide();
    });
    Object.keys(this.latestRoomSceneTitles).forEach(key => {
      this.latestRoomSceneTitles[key].hide();
    });
  }
  createPrivateChat(e) {
    let id = e.data.userId || e.data.senderId;
    if (e.data.id) {
      id = e.data.id;
    }
    let data = this.socket.getUsersObject()[id] //|| savedData[id];
    if (!data) {
      data = e.data;
    }
    data.img = data.userAvatarUrl ? data.userAvatarUrl : data.senderAvatarUrl;
    /// PVT 1-on-1 chat
    this.latestRoomSceneTitles[id] = new ChatPanelTitle({
      id,
      img: data.img,
      title: `${data.userName}`,
      lastMessage: e.data.text,
      timestamp: "Now",
      type: types.PRIVATE,
      container: this.latestChats,
      model: this.model,
      socket: this.socket
    });
    this.privateChats[id] = new NewChatComponent({ id, name: data.userName, type: types.PRIVATE, isGuest: data.isGuest, model: this.model });
  }
  createPrivateOfflineChat(e) {
    const user = this.model.friends.offline.filter(friend => friend.id === e.data.id)[0]
    this.latestRoomSceneTitles[user.id] = new ChatPanelTitle({
      id: user.id,
      img: user.avatar_image_url,
      title: `${user.username}`,
      lastMessage: "",
      timestamp: "Yesterday",
      type: types.PRIVATE,
      container: this.latestChats,
      model: this.model,
      socket: this.socket
    });
    this.privateChats[user.id] = new NewChatComponent({ id: user.id, name: user.username, type: types.PRIVATE, model: this.model });
  }
  createLatestChat(user) {
    this.latestRoomSceneTitles[user.id] = new ChatPanelTitle({
      id: user.id,
      img: user.avatarImageUrl || '/textures/defaultAvatar.png',
      title: `${user.username}`,
      lastMessage: "",
      timestamp: "Yesterday",
      type: types.PRIVATE,
      container: this.latestChats,
      model: this.model,
      socket: this.socket
    });
    this.privateChats[user.id] = new NewChatComponent({ id: user.id, name: user.username, type: types.PRIVATE, model: this.model });
  }
  createChessChat(e) {
    const { id } = e.data;
    this.chessChats[id] = new NewChatComponent({ id, name: `chess-chat-${id}`, type: types.CHESS, model: this.model });
    //creates titles inside panel - clicks - opens chat
    this.currentRoomSceneTitles[id] = new ChatPanelTitle({
      id,
      img: "",
      title: `Chess`,
      lastMessage: "",
      timestamp: "",
      type: types.CHESS,
      container: this.currentRoomChats,
      model: this.model,
      img: "/textures/icons/chess-chat-icon.png"
    });
  }
}
